import React, { Component } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom'; // eslint-disable-line no-unused-vars

class TriGrid extends Component {
  render() {
    return (
    <div className="app-tri-grid__item">
        <div className="app-tri-grid__img-container">
            <img className="app-tri-grid__img" src={this.props.img} alt={this.props.title} />
        </div>
        <div className="app-tri-grid__content">
            <h3>{this.props.title}</h3>
            <p>{this.props.summary} ...<Link to={`/${this.props.link}`}>more</Link></p>
            
        </div>
    </div>
    )
  }
}

export default TriGrid



// WEBPACK FOOTER //
// ./src/shared/trigrid.js